import { FC } from 'react';

import { AdBanner } from './AdBanner';
import { Banner } from './Banner';
import { Bestsellers } from './Bestsellers';
import { FaqBanner } from './FaqBanner';
import { GameReleasesHero } from './GameReleasesHero';
import { MobileBanner } from './MobileBanner';
import { PremiumOffersPreview } from './PremiumOffersPreview';
import { Products } from './Products';
import { ProductTypesList } from './ProductTypesList';

const Index: FC = () => (
    <main className="flex-1">
        <GameReleasesHero />

        <Banner />

        <ProductTypesList />

        <MobileBanner />

        <PremiumOffersPreview />

        <Bestsellers />

        <Products />

        <div className="hidden md:block">
            <AdBanner className="mb-4 sm:mb-6" />
        </div>

        <div className="md:hidden">
            <AdBanner className="mb-4 sm:mb-6" />
        </div>

        <FaqBanner />
    </main>
);

export default Index;
